
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { CivicEducationItem, transformDatabaseContent } from '@/types/civic-education';
import { toast } from 'sonner';

export const useCivicEducationContent = () => {
  const [allContent, setAllContent] = useState<CivicEducationItem[]>([]);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  
  useEffect(() => {
    fetchAllContent();
  }, []);
  
  const fetchAllContent = async () => {
    try {
      setIsLoadingContent(true);
      
      // Fetch from civic_education_content table 
      const { data, error } = await supabase
        .from('civic_education_content')
        .select('*')
        .order('created_at', { ascending: false });
      
      if (error) {
        console.error('Error fetching civic education content:', error);
        throw error;
      }

      if (data && data.length > 0) {
        // Transform database records to our CivicEducationItem format
        const transformedContent = data.map(item => transformDatabaseContent(item));
        setAllContent(transformedContent);
      } else {
        // If no data exists yet, set empty array
        setAllContent([]);
      }
    } catch (error) {
      console.error('Error fetching all content:', error);
      toast.error('Failed to load civic education content');
      
      // Fall back to empty array on error
      setAllContent([]);
    } finally {
      setIsLoadingContent(false);
    }
  };
  
  return {
    allContent,
    isLoadingContent,
    refreshContent: fetchAllContent
  };
};
